export const DEBUG = {
  columns: false,    // Column-related logs
  data: true,       // Data loading logs
  filters: true,    // Filter-related logs
  sync: false,      // User data sync logs
  settings: false,  // Settings-related logs
  market: false     // Market analysis logs
}; 